/* MOF lead hook (Simon 2026-10-29; Jay: "let Codex do OpenAI, and you do Google").
 * ONE "lead accepted" signal for every lead path. Simon fires Google from here; Codex's mof-tracking.js listens to the
 * `mof:lead` event and fires OpenAI. Ad source = the 30-day store mof-tracking.js already keeps (mof_ad_attribution_v1).
 *   MOFLead.accepted('catalog' | 'chat', { email })   - call ONLY after GHL / Mira returned success
 *   website form: counted here on /pages/thank-you, once, only if the GHL form was shown in this tab within 2 hours
 */
(function () {
  'use strict';
  if (window.MOFLead) return;

  var GOOGLE_POPUP_CHAT = 'AW-761521344/OOxQCLusvK4dEMDJj-sC'; // "Website lead - pop-up or chat" (the form keeps its URL action)
  var ATTR_KEY = 'mof_ad_attribution_v1';
  var FORM_KEY = 'mof_form_shown_v1';
  var FORM_ID = 'N3YLAfcctX5t8CYPBgQv';
  var FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid',
    'oppref', 'oai_campaign_id', 'oai_ad_group_id', 'oai_ad_id', 'oai_ad_account_id', 'source_lane', 'landing_path', 'captured_at'];

  function read(key) {
    try { return JSON.parse(sessionStorage.getItem(key) || localStorage.getItem(key) || 'null'); } catch (e) { return null; }
  }
  function newId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return 'mof-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
  }
  function isTest(email) { return /jay(\+[^@]*)?@miramaroffice\.com|test/i.test(String(email || '')); }
  function source() {
    var a = read(ATTR_KEY) || {}, out = {};
    if (a.expires_at && Number(a.expires_at) < Date.now()) return out;
    FIELDS.forEach(function (k) { if (a[k]) out[k] = String(a[k]).slice(0, 300); });
    return out;
  }

  function accepted(path, opts) {
    opts = opts || {};
    var detail = { eventId: opts.eventId || newId(), path: path, test: !!opts.test || isTest(opts.email), source: source() };
    if (!detail.test && path !== 'form' && typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', { send_to: GOOGLE_POPUP_CHAT, transaction_id: detail.eventId });
    }
    try { document.dispatchEvent(new CustomEvent('mof:lead', { detail: detail })); } catch (e) { /* old browser */ }
    return detail;
  }

  window.MOFLead = { accepted: accepted, source: source, isTest: isTest };

  // OpenAI (ChatGPT Ads) lead, on the same signal. Simon 2026-10-29 on Jay's go after Codex stalled; uses Codex's own
  // MOFOpenAIPixel.measureLead from mof-tracking.js, with the shared eventId so the two platforms dedupe. Tests never fire.
  document.addEventListener('mof:lead', function (e) {
    var d = e.detail || {};
    if (d.test || !d.eventId) return;
    if (window.MOFOpenAIPixel && typeof window.MOFOpenAIPixel.measureLead === 'function') window.MOFOpenAIPixel.measureLead(d.eventId);
  });

  function onReady() {
    // Pages with the GHL form: remember it was shown, and put the stored ad tags back in the address bar so GHL's own
    // attribution (it reads the page URL at submit) records the ad even after the visitor clicked around.
    if (document.querySelector('iframe[data-form-id="' + FORM_ID + '"]')) {
      try { sessionStorage.setItem(FORM_KEY, String(Date.now())); } catch (e) { /* storage off */ }
      var s = source(), q = new URLSearchParams(location.search), added = false;
      if (!q.get('utm_source') && !q.get('gclid')) {
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid'].forEach(function (k) {
          if (s[k]) { q.set(k, s[k]); added = true; }
        });
        if (added && window.history && history.replaceState) history.replaceState(history.state, '', location.pathname + '?' + q.toString() + location.hash);
      }
    }
    // GHL sends the visitor to /pages/thank-you only after it accepted the form.
    if (/^\/pages\/thank-you\/?$/.test(location.pathname)) {
      var shown = 0;
      try { shown = Number(sessionStorage.getItem(FORM_KEY) || 0); sessionStorage.removeItem(FORM_KEY); } catch (e) { /* storage off */ }
      if (shown && Date.now() - shown < 2 * 3600 * 1000) accepted('form');
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady); else onReady();
})();
